module.exports = __webpack_public_path__ + "static/img/main_background.7252da21.svg";